const Languages = {
  en: 'EN',
  he: 'HE'
};

const DefaultLanguage = 'en';

export {
  Languages,
  DefaultLanguage
};
